import { gql } from '@apollo/client';

export const PATCH_ASSET = gql`
    mutation patchAsset($input: AssetInput!) {
        result: patchAsset(input: $input) {
          id
          name
          url
          mimetype
          encoding
          createdAt
          updatedAt
          locales
        }
    }
`;